import { render } from "./SiteForm.vue?vue&type=template&id=404b6b56"
import script from "./SiteForm.vue?vue&type=script&lang=js"
export * from "./SiteForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__